import { defineMessages, useIntl } from "react-intl";
import { Button } from "~/components/ui/button";

type ShowMoreResultsProps = {
  type: "documents" | "cases";
  handleClick: () => void;
};

const messages = defineMessages({
  documents: {
    id: "search.showMoreDocuments",
    defaultMessage: "Show More Documents",
  },
  cases: {
    id: "search.showMoreCases",
    defaultMessage: "Show More Cases",
  },
});

export const ShowMoreResults: React.FC<ShowMoreResultsProps> = ({
  type,
  handleClick,
}) => {
  const intl = useIntl();
  return (
    <Button
      variant="link"
      className="text-blue-600 text-xs self-start p-2 hover:no-underline h-auto"
      onClick={handleClick}
    >
      {intl.formatMessage(messages[type])}
    </Button>
  );
};
